<div class="k2-sync-container">
  <table class="gt-reclass-table table table-condensed">
    <thead>
      <tr>
        <th colspan="16" style="width: 100%;">K2 Sync</th>
      </tr>
    </thead>
  </table>

  <br>

  <div class="row form-row">
    <!-- Tax Year -->
    <div class="col-md-2 col-md-offset-1">
      <label>Tax Year :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedTaxYear"
                name="selectedTaxYear"
                (ngModelChange)="getScenarioDropDown()">
          <option value="">-- Select --</option>
          @for (ty of filteredTaxYearData; track $index) {
<option
                  [value]="ty.CODE_DISP_DESC">
            {{ ty.CODE_SHORT_DESC }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- Scenario -->
    @if (selectedTaxYear) {
<div class="col-md-2">
      <label>Scenario :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedScenario"
                name="selectedScenario"
                (ngModelChange)="getFormDropdown()">
          <option value="">-- Select --</option>
          @for (s of scenarioDropDown; track $index) {
<option
                  [value]="s.VALUE">
            {{ s.LABEL }}
          </option>
}
        </select>
      </div>
    </div>
}

    <!-- Form -->
    @if (selectedTaxYear && selectedScenario) {
<div class="col-md-2">
      <label>Form :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedForm"
                name="selectedForm"
                (ngModelChange)="getParentMeDropdown()">
          <option value="">-- Select --</option>
          @for (f of formDropDown; track $index) {
<option
                  [value]="f.VALUE">
            {{ f.LABEL }}
          </option>
}
        </select>
      </div>
    </div>
}

    <!-- Parent ME(s) -->
    @if (loadParentMEDropdown && selectedForm) {
<div class="col-md-2">
      <label>Parent ME(s) :</label>
      @if (!loadingParentME) {
<div>
        <select class="form-control"
                [(ngModel)]="selectedParentMes"
                name="selectedParentMes"
                (ngModelChange)="getPshipDropdown()">
          <option value="">-- Select --</option>
          @for (p of parentMEDropDown; track $index) {
<option
                  [value]="p.PARENT_ME_KEY">
            {{ p.PARENT_ME_NAME }}
          </option>
}
        </select>
      </div>
}
      @if (loadingParentME) {
<div class="input-group">
        <input type="text" class="form-control input-sm" disabled placeholder="loading"
               style="height: 34px;">
        <span class="input-group-addon">
          <i class="fa fa-spinner fa-pulse"></i>
        </span>
      </div>
}
    </div>
}

    <!-- Partnership -->
    @if (showPship) {
<div class="col-md-2">
      <label>Partnership :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedPship"
                name="selectedPship">
          <option value="">-- Select --</option>
          @for (ps of pshipDropDown; track $index) {
<option
                  [value]="ps.VALUE">
            {{ ps.LABEL }}
          </option>
}
        </select>
      </div>
    </div>
}
  </div>

  <div class="row button-row">
    <div class="col-md-3 col-md-offset-7">
      <button class="btn btn-info btn-sm"
              type="button"
              [disabled]="syncRunning"
              (click)="runSyncProcess()">
        @if (syncRunning) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
        Run Sync
      </button>
      &nbsp;&nbsp;&nbsp;
      <button class="btn btn-danger-outline btn-sm"
              type="button"
              (click)="reset()">
        Reset
      </button>
    </div>
  </div>
</div>

@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmYes()"
    (cancelled)="onConfirmNo()"
    (closed)="onConfirmNo()">
  </gtw-confirmation-modal>
</div>
}
